import create from 'zustand'
import { persist } from 'zustand/middleware'
import { EmployeeSearch } from '../../../types'

interface IEmployeeSearchState {
  search: string
  searchLabel: string
  setSearch: (search: string) => void
  setSearchLabel: (setSearchLabel: string) => void
  latestSearchResults: EmployeeSearch[]
  setLatestSearchResults: (latestSearchResults: EmployeeSearch[]) => void
  resetStore: () => void
}

const initialValues = {
  search: '',
  searchLabel: '',
  latestSearchResults: <EmployeeSearch[]>[],
}

// Store state persisted to the local storage
export const useEmployeeSearchStore = create<IEmployeeSearchState>(
  persist(
    (set) => ({
      ...initialValues,
      setSearch: (search: string) => set({ search }),
      setSearchLabel: (searchLabel: string) => set({ searchLabel }),
      setLatestSearchResults: (latestSearchResults: EmployeeSearch[]) => set({ latestSearchResults }),
      resetStore: () => set({ ...initialValues }),
    }),
    { name: 'search-storage' },
  ),
)
